import { Component, Input, ViewChild } from "@angular/core";
import { FormGroup } from '@angular/forms';
import { NgbCalendar, NgbDate, NgbDatepicker } from "@ng-bootstrap/ng-bootstrap";

@Component({
  standalone: false,
  selector: 'app-popup-ngbDate-picker',
  template: `
  <div [formGroup]="formGroup">
    <div [formGroupName]="fGroupName">
      <fieldset [formGroupName]="fieldSetName">
        <div class="input-group">
          <input sdInputMask maxlength="11" class="form-control {{extraCss}}" [formControlName]="fControlName" [placeholder]="placeholder"
            [readonly]="readonly" [ngStyle]="{'background-color':'#ffffff'}"
            [minDate]="minDate" [maxDate]="maxDate" [value]="value"
              name="dp" ngbDatepicker #datepicker="ngbDatepicker" placement="bottom">
          <div class="input-group-append">
            <button class="btn btn-outline-secondary calendar" (click)="datepicker.toggle()" type="button"></button>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
  `
})
export class PopupNgbDatePickerComponent {

  @Input()
  minDate: NgbDate = this.calendar.getNext(this.calendar.getToday(), 'm', -38);

  @Input()
  maxDate: NgbDate;

  @Input()
  formGroup: FormGroup;

  @Input()
  fGroupName: string;

  @Input()
  fieldSetName: string;

  @Input()
  fControlName: string;

  @ViewChild('datepicker')
  datepicker: NgbDatepicker;

  @Input()
  readonly = 'true';

  @Input()
  placeholder = 'mm/dd/yyyy';

  @Input()
  extraCss = '';

  value: string;

  constructor(
    private calendar: NgbCalendar,
  ) { };

}